<template>
    <div class="common-button" :class="[widthClass, buttonClass]">
      <b-button
        :disabled="disabled"
        @click="handleClick"
        class="rounded-pill position-relative"
        :class="{
          'button-opacity': loading,
          'align-items-end': type === 'filter',
  
        }"
      >
			<img v-if="type === 'add'" src="../assets/images/common/add-plus.svg" alt="" />
      <img
				v-if="type === 'withdraw'"
				src="../assets/images/common/withdrawl.svg"
				alt=""
			/>
        <span  class="text-nowrap text-capitalize"
        :class="{
          'invisible':loading
        }"
        >
          {{
          text
        }}</span>
        <div class="loader-position" v-if="loading">
          <Loader />
        </div>
      </b-button>
    </div>
  </template>
  
  <script>
  import Loader from "../components/Loader.vue";
  export default {
    name: "PrimaryButton",
    components: {
      Loader,
    },
  
    props: {
      text: {
        type: String,
        default: "",
      },
      loading: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      widthClass: {
        type: String,
        default: "button-fit-content",
      },
      redButton: {
        type: Boolean,
        default: false,
      },
    },
    computed:{
      buttonClass(){
        return this.redButton ? 'red-buttonnew' : 'blue-buttonnew';
      }
    },
    methods: {
      handleClick() {
        if (!this.loading) {
          this.$emit("clicked");
        }
      },
    },
  };
  </script>
  
  <style>
  .button-opacity {
    opacity: 50%;
    height: 25px;
  }
  .loader-position {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .fix-loader-position {
    position: absolute;
    bottom: 5px;
    left: -11px;
  }
  .common-button .spinner-border {
    height: 1.563rem;
    width: 1.563rem;
    margin-top: 0.188rem;
    border: 0.25em solid var(--color-white);
    border-right-color: transparent;
  }
  
  .common-button .btn-secondary {
    color: var(--color-white);
    padding: 0.25rem 1.125rem;
    font-family: "Montserrat", sans-serif;
    font-size: var(--size-13);
    font-weight: var(--weight-600);
    display: flex;
    align-items: normal;
    justify-content: center;
    gap: 0.625rem;
    width: 100%;
    min-height: 30px;
  }
  /* change to red color */
  .common-button .btn-secondary.red-bg {
    background-color: var(--validation-color) !important;
    border: unset !important;
  }
  .common-button .btn-secondary.red-bg:active {
    background-color: var(--validation-color) !important;
    border: unset !important;
  }
  .common-button .btn-secondary.disabled,
  .btn-secondary:disabled {
    opacity: 0.65 !important;
  }
  
  .common-button .btn-secondary:hover {
    box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
      2px 3px 7px 0px rgba(32, 99, 155, 0.2),
      7px 10px 12px 0px rgba(32, 99, 155, 0.17),
      44px 63px 22px 0px rgba(32, 99, 155, 0);

  }

  .blue-buttonnew .btn-secondary:hover {
    background-color: var(--primary-blue) !important;
  }

  .common-button .btn-secondary:focus {
    color: var(--color-white);
    box-shadow: none;
  }
  
  .common-button .btn-secondary:disabled {
    color: var(--color-white) !important;
    box-shadow: none;
  }
  
  .common-button .btn-secondary:focus {
    color: var(--color-white);
    box-shadow: none;
  }
  
  .blue-buttonnew .btn-secondary {
    background-color: var(--primary-blue);
    border: 1px solid var(--primary-blue);
  }
  
  .blue-buttonnew .btn-secondary:focus {
    border: 1px solid var(--primary-blue);
  }
  
  .blue-buttonnew .btn-secondary:focus {
    border: 1px solid var(--primary-blue);
  }
  
  .blue-buttonnew .btn-secondary:disabled{
    background-color: var(--primary-blue) !important;
    border-color: var(--primary-blue) !important;
  }
  
  .blue-buttonnew .btn-secondary:not(:disabled):not(.disabled):active,
  .blue-buttonnew .btn-secondary:not(:disabled):not(.disabled).active,
  .blue-buttonnew .show > .btn-secondary.dropdown-toggle {
    color: var(--color-white) !important;
    background-color: var(--primary-blue) !important;
    border-color: var(--primary-blue) !important;
    box-shadow: none;
    border-color: unset;
  }

  .red-buttonnew .btn-secondary:hover {
    background-color: var(--validation-color) !important;
  }
  
  .red-buttonnew .btn-secondary {
    background-color: var(--validation-color);
    border: 1px solid var(--validation-color);
  }
  
  .red-buttonnew .btn-secondary:focus {
    border: 1px solid var(--validation-color);
  }
  
  .red-buttonnew .btn-secondary:focus {
    border: 1px solid var(--validation-color);
  }
  
  .red-buttonnew .btn-secondary:disabled{
    background-color: var(--validation-color) !important;
    border-color: var(--validation-color) !important;
  }
  
  .red-buttonnew .btn-secondary:not(:disabled):not(.disabled):active,
  .red-buttonnew .btn-secondary:not(:disabled):not(.disabled).active,
  .red-buttonnew .show > .btn-secondary.dropdown-toggle {
    color: var(--color-white) !important;
    background-color: var(--validation-color) !important;
    border-color: var(--validation-color) !important;
    box-shadow: none;
  }
  .button-width {
    width: 5.625rem;
  }
  
  .button-fit-content {
    width: fit-content;
  }
  /*button width 200px */
  
  .w-200px {
    width: 200px;
  }
  .w-110px {
    width: 110px;
  }
  .w-110px button {
    height: 25px;
    display: flex;
    align-items: center !important;
    justify-content: center;
  }
  .w-110-h32 {
    width: 110px;
  }
  .w-250px button{
    width: 250px !important;
    height: 40px;
    display: flex !important;
    align-items: center !important;
  }
  .w-110-h32 button {
    height: 32px !important;
    display: flex;
    align-items: center !important;
    justify-content: center;
  }
  .h-32 button {
    height: 32px !important;
    display: flex;
    align-items: center !important;
    justify-content: center;
  }
  .w-full-btn button {
    width: 100%;
    height: 42px !important;
    display: flex;
    align-items: center !important;
    justify-content: center;
  }
  .review-btn button {
    background: transparent !important;
  }
  </style>
